import Layout from "../Layout";
import Loader from "../Layout/loader";
import { useEffect, useState } from "react";

import { FaPlus, FaFileImport } from "react-icons/fa6";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import { IoSearchSharp } from "react-icons/io5";

import ModalProdutos from "./modal";

import { cores, itemsList } from "../Layout/constants";
import { useSearchParams } from "react-router-dom";

import axios from "axios";

import {
  codigoEvento,
  convertAPIColor,
  codigoParaCor,
  codigoParaImagem,
  codigoParaLabel,
  codigoParaImagemLabel,
} from "../Utils/utils";

function Produtos() {
  useEffect(() => {
    const openModalCreateProduct = searchParams.get("modaltype");
    if (openModalCreateProduct === "create") {
      setOpenModal(true);
      setModalType("create");
    }

    getProdutos();
  }, []);

  async function getProdutos() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Grupo`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      })
      .then((data) => {
        if (data.status === 200) {
          axios
            .get(`${process.env.REACT_APP_API_URL}/Produto`, {
              headers: { auth: process.env.REACT_APP_API_TOKEN },
              params: {
                codaluguel: codigoEvento(),
              },
            })
            .then((res) => {
              if (res.status === 200) {
                setProdutos(res.data);
                setIsLoading(false);

                let grupos = data.data.map((grupo) => {
                  if (!grupo.DESCRICAO) grupo.DESCRICAO = "";

                  const produtosGrupo = res.data.filter(
                    (produto) => produto.CODGRUPO === grupo.CODIGO
                  );
                  grupo.PRODUTOS = produtosGrupo;

                  if (produtosGrupo.length > 0) {
                    res.data = res.data.filter(
                      (produto) => produto.CODGRUPO !== grupo.CODIGO
                    );
                  }

                  return grupo;
                });

                if (res.data.length > 0) {
                  grupos.push({
                    CODIGO: null,
                    DESCRICAO: "Sem Grupo",
                    PRODUTOS: res.data,
                  });
                }

                grupos = grupos.sort((a, b) => {
                  if (a.DESCRICAO === "Sem Grupo") return -1;
                  if (b.DESCRICAO === "Sem Grupo") return 1;
                  return 0;
                });

                setGrupos(grupos);

                setGruposList(() => {
                  return data.data.map((grupo) => {
                    return {
                      label: grupo.DESCRICAO,
                      value: grupo.CODIGO,
                      cor: grupo.COR,
                      corLabel: codigoParaLabel(convertAPIColor(grupo.COR)),
                      color: convertAPIColor(grupo.COR),
                      image: `/icone/${grupo.IMAGEM}`,
                      imagemLabel: codigoParaImagemLabel(
                        `/icone/${grupo.IMAGEM}`
                      ),
                    };
                  });
                });

                /*setGruposList((prev) => {
                  return [
                    {
                      label: "Sem Grupo",
                      value: null,
                      cor: "azulEscuro",
                      corLabel: "Azul Escuro",
                      color: "#4682B4",
                      image: "/icone/24.png",
                      imagemLabel: "Ficha",
                    },
                    ...prev,
                  ];
                });*/
              } else {
                setIsLoading(false);
              }
            })
            .catch((error) => {
              setIsLoading(false);
            });
        }
      });
  }

  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [produtos, setProdutos] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalData, setModalData] = useState({});
  const [filtro, setFiltro] = useState("");
  const [gruposList, setGruposList] = useState([]);

  const filtrados =
    filtro.trim() === ""
      ? grupos
      : grupos.filter((grupo) =>
          grupo.PRODUTOS.some(
            (produto) =>
              produto.DESCRICAO.toLowerCase().includes(filtro.toLowerCase()) ||
              produto.CODIGO.toString().includes(filtro)
          )
        );

  async function handleCloseModal() {
    setOpenModal(false);
    setModalType("");
    setModalData({});
  }

  async function handleSubmit(data) {
    data.cor = codigoParaCor(data.cor);
    data.imagem = codigoParaImagem("/icone/" + data.imagem);

    data.comissaoValor = data.valorComissao ? data.valorComissao : 0.0;
    data.comissaoPorc = data.porcComissao ? data.porcComissao : 0.0;
    data.grupo = data.grupo != "" ? data.grupo : 0;
    data.codGrupo = data.grupo != "" ? data.grupo : null;
    //data.nomeGrupo = data.grupoNome ?? "";
    data.grupoIngresso = data?.grupoIngresso != "" ? data?.grupoIngresso : 0;
    data.codIngresso = data?.grupoIngresso != "" ? data?.grupoIngresso : 0;

    data.codaluguel = codigoEvento();
    data.precoVenda = data.valor;
    data.codigo = data.codigo.toString() ?? null;
    data.unidade = data.unidade ?? "";
    data.promo = data.promo ? "S" : "N";
    data.ativo = data.ativo ?? false;
    data.vendaPeso = data.vendaPeso ?? false;
    data.ingresso = data.ingresso ?? false;

    Object.keys(data).forEach((key) => {
      if (data[key] === null) {
        delete data[key];
      }
    });

    if (modalType === "create") {
      data.codigo = "";
      criar(data);
    } else if (modalType === "edit") {
      alterar(data);
    } else if (modalType === "delete") {
      excluir(data);
    }
  }

  async function criar(data) {
    let postData = {
      codaluguel: codigoEvento(),
      produto: [data],
    };
    axios
      .post(`${process.env.REACT_APP_API_URL}/Produto`, postData, {
        headers: {
          auth: process.env.REACT_APP_API_TOKEN,
          "Content-Type": "application/json",
        },
      })
      .then((retorno) => {
        getProdutos();
      });
  }
  async function alterar(data) {
    axios
      .put(`${process.env.REACT_APP_API_URL}/Produto`, data, {
        headers: {
          auth: process.env.REACT_APP_API_TOKEN,
          "Content-Type": "application/json",
        },
      })
      .then((retorno) => {
        getProdutos();
      });
  }
  async function excluir(data) {
    axios
      .delete(`${process.env.REACT_APP_API_URL}/Produto`, {
        headers: {
          auth: process.env.REACT_APP_API_TOKEN,
          "Content-Type": "application/json",
        },
        params: {
          codaluguel: codigoEvento(),
          codProd: data.codigo,
        },
      })
      .then((retorno) => {
        getProdutos();
      });
  }

  async function importar(data) {
    for (const produto of data) {
      produto.cor = codigoParaCor(produto.cor);
      produto.imagem = codigoParaImagem("/icone/" + produto.imagem);

      produto.comissaoValor = produto.valorComissao
        ? produto.valorComissao
        : 0.0;
      produto.comissaoPorc = produto.porcComissao ? produto.porcComissao : 0.0;
      produto.grupo = produto.grupo != "" ? produto.grupo : 0;
      produto.codGrupo = produto.grupo != "" ? produto.grupo : "";
      //data.nomeGrupo = data.grupoNome ?? "";
      produto.grupoIngresso =
        produto?.grupoIngresso != "" ? produto?.grupoIngresso : 0;
      produto.codIngresso =
        produto?.grupoIngresso != "" ? produto?.grupoIngresso : 0;

      produto.codaluguel = codigoEvento();
      produto.precoVenda = produto?.valor;
      produto.codigo = produto?.codigo?.toString() ?? "";
      produto.unidade = produto?.unidade ?? "UN";
      produto.promo = produto?.promo ? "S" : "N";
      produto.ativo = produto?.ativo ?? "S";
      produto.vendaPeso = produto?.vendaPeso ?? "N";
      produto.ingresso = produto?.ingresso ?? false;
      produto.grupoIngresso = produto?.grupoIngresso ?? "";
      produto.grupo = produto?.grupo ?? "";
      produto.codGrupo = produto?.grupo ?? "";
      produto.codIngresso = produto?.grupoIngresso ?? "";
      produto.precoVenda = produto?.precoVenda ?? 0;
    }

    let postData = {
      codaluguel: codigoEvento(),
      produto: data,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/Produto`, postData, {
        headers: {
          auth: process.env.REACT_APP_API_TOKEN,
          "Content-Type": "application/json",
        },
      })
      .then((retorno) => {
        getProdutos();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  return (
    <Layout>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="font-Roboto flex box-border p-2 lg:p-12 flex-col gap-4 justify-center items-center w-full">
          {openModal ? (
            <ModalProdutos
              cores={cores}
              grupos={gruposList}
              produtos={produtos}
              itemsList={itemsList}
              modalData={modalData}
              type={modalType}
              onSubmit={handleSubmit}
              onClose={handleCloseModal}
              onImportar={importar}
            />
          ) : null}
          <div className="flex flex-col gap-2 w-full lg:w-[80%] justify-center items-center">
            <h1 className="font-Oswald">Produtos</h1>
          </div>

          <div className="flex gap-4 flex-wrap w-full justify-between lg:w-[80%]">
            <div className="flex gap-2 items-center">
              <button
                onClick={() => {
                  setOpenModal(true);
                  setModalType("create");

                  setModalData({});
                }}
                className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
              >
                <FaPlus />

                <span>Produto</span>
              </button>
              <button
                onClick={() => {
                  setOpenModal(true);
                  setModalType("import");

                  setModalData({});
                }}
                className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
              >
                <FaFileImport />

                <span>Importar</span>
              </button>
            </div>

            <input
              type="text"
              placeholder="Pesquisar Produto..."
              className="p-2 text-base rounded-lg border border-solid border-gray-200"
              value={filtro}
              onChange={(e) => setFiltro(e.target.value)}
            />
          </div>

          <div className="flex flex-col h-auto gap-2 box-border overflow-visible rounded-lg w-full lg:w-[80%]">
            {filtrados.map((grupo, i) => (
              <>
                <div
                  key={grupo.CODIGO + i}
                  className="flex text-black p-2 lg:p-4"
                >
                  <h4>
                    {grupo.CODIGO ? grupo.CODIGO : "Sem Código"} -{" "}
                    {grupo.DESCRICAO}
                  </h4>
                </div>
                {grupo.PRODUTOS.map((produto, j) => (
                  <div
                    key={produto.DESCRICAO + j}
                    style={{ backgroundColor: convertAPIColor(produto.COR) }}
                    className="flex justify-between items-center p-2 lg:p-4 border rounded-lg border-solid border-gray-200 text-white"
                  >
                    <div className="flex gap-2 items-center max-w-[70%] overflow-hidden">
                      <img
                        className="w-[30px] shrink-0"
                        src={`/icone/${produto.IMAGEM}`}
                        alt="Grupo"
                      />
                      <div className="flex flex-col text-left overflow-hidden">
                        <p className="whitespace-nowrap text-ellipsis overflow-hidden">
                          {produto.CODIGO} - {produto.DESCRICAO}
                        </p>
                        <p>
                          {Number(produto.PRECOVENDA).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-2 items-center justify-end shrink-0">
                      <button
                        onClick={() => {
                          setOpenModal(true);
                          setModalType("edit");
                          setModalData(produto);
                        }}
                        className="flex gap-2 font-[500] items-center rounded-lg text-lg border border-solid border-black p-3 transition cursor-pointer hover:bg-gray-300 font-Roboto"
                      >
                        <FaPencilAlt />
                      </button>
                      <button
                        onClick={() => {
                          setOpenModal(true);
                          setModalType("view");
                          setModalData(produto);
                        }}
                        className="flex gap-2 font-[500] items-center rounded-lg text-lg border border-solid border-black p-3 transition cursor-pointer hover:bg-gray-300 font-Roboto"
                      >
                        <IoSearchSharp />
                      </button>
                      <button
                        onClick={() => {
                          setOpenModal(true);
                          setModalType("delete");
                          setModalData(produto);
                        }}
                        className="flex gap-2 font-[500] items-center rounded-lg text-lg border border-solid border-black p-3 transition cursor-pointer hover:bg-gray-300 font-Roboto"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </div>
                ))}
              </>
            ))}
          </div>
        </div>
      )}
    </Layout>
  );
}
export default Produtos;
